import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn_route_ts",
  "use": "icon-warn_route_ts-usage",
  "viewBox": "0 0 571.28 829.11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 571.28 829.11\" id=\"icon-warn_route_ts\"><defs></defs><g id=\"icon-warn_route_ts_图层_2\" data-name=\"图层 2\"><g id=\"icon-warn_route_ts_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M164,0h301.1A24.58,24.58,0,0,1,487,35.72L368.51,268.49l178.18.23c21,0,32.32,24.78,18.53,40.68L114.44,829.11l139.76-357H24.59A24.57,24.57,0,0,1,1.25,439.8L140.64,16.88A24.58,24.58,0,0,1,164,0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol